import React from 'react';
import { useTranslation } from 'react-i18next';

const SEOKeywordContent = ({ page = 'home' }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Invisible content for SEO keyword targeting
  const getKeywordContent = () => {
    if (currentLanguage === 'en') {
      return {
        home: `Rwanda traffic rules driving license preparation provisional driving test Rwanda provisoire Ikizamini Ibyapa Twara driving exam questions how to pass Rwanda driving exam AB Drive driving school Rwanda road test permit test Rwanda driving theory test Rwanda traffic laws Rwanda driver education Rwanda provisional license Rwanda provisoire Rwanda driving exam preparation Rwanda DMV test Ikizamini Rwanda Ibyapa Rwanda Twara Rwanda Rwanda traffic regulations road signs Rwanda Ibyapa vehicle features road conditions driving course Rwanda`,
        course: `Rwanda traffic rules course driving license preparation Rwanda Rwanda driving exam questions Ikizamini provisional driving test Rwanda provisoire traffic laws Rwanda road rules Rwanda driving education course Rwanda permit course traffic regulations Rwanda Ibyapa course Twara training comprehensive driving course interactive learning Rwanda`,
        quiz: `Rwanda driving exam questions Ikizamini provisional driving test Rwanda provisoire how to pass Rwanda driving exam Rwanda traffic rules quiz driving test practice Rwanda permit test questions Rwanda Ibyapa quiz Twara practice Rwanda road test questions driving exam preparation practice tests driving license quiz`
      };
    } else if (currentLanguage === 'fr') {
      return {
        home: `Règles de circulation au Rwanda examen permis de conduire Rwanda permis provisoire Rwanda provisoire Ikizamini Ibyapa Twara auto-école Rwanda préparation permis de conduire Rwanda école de conduite Rwanda code de la route Rwanda formation permis Rwanda test permis Rwanda éducation routière Rwanda permis théorique Rwanda cours conduite Rwanda`,
        course: `cours règles de circulation Rwanda auto-école Rwanda préparation permis de conduire Rwanda examen permis de conduire Rwanda formation conduite Rwanda école de conduite Rwanda permis provisoire Rwanda provisoire Ikizamini cours Ibyapa cours Twara formation formation complète conduite interactive apprentissage`,
        quiz: `examen permis de conduire Rwanda Ikizamini permis provisoire Rwanda provisoire auto-école Rwanda test permis Rwanda quiz règles circulation Rwanda Ibyapa quiz Twara pratique préparation examen conduite Rwanda questions permis conduire tests pratiques quiz conduite`
      };
    } else if (currentLanguage === 'rw') {
      return {
        home: `amategeko y'umuhanda ikizamini cy'uruhushya rw'agateganyo ikizamini ikizamini cy'agateganyo ikizamini cy'amategeko ikizamini cy'uruhushya ibibazo bya perimi provisoire perimi provisoire provisoire twara kwiga twara twara neza uko twara ibyapa ibyapa by'umuhanda kwiga ibyapa ibyapa by'umuhanda mu Rwanda AB Drive kwiga amategeko y'umuhanda amategeko y'umuhanda mu Rwanda ibimenyetso by'umuhanda ibimenyetso by'umuhanda mu Rwanda perimi ya provisoire uruhushya rw'agateganyo ikizamini cy'uruhushya rw'agateganyo mu Rwanda ishuri ry'amategeko ishuri ry'amategeko y'umuhanda ikizamini cy'amategeko y'umuhanda kwiga twara neza menya ibyapa menya ibimenyetso ikizamini cyiza ikizamini cy'uruhushya rw'agateganyo rwo gutwara kwiga ikizamini witegura ikizamini ikizamini cy'amategeko y'umuhanda mu Rwanda amasomo amategeko`,
        course: `kwiga amategeko y'umuhanda amasomo y'amategeko y'umuhanda amasomo y'amategeko ibibazo bya perimi provisoire perimi provisoire provisoire amasomo twara kwiga twara amasomo yo kwiga twara neza ibyapa kwiga ibyapa amasomo y'ibyapa ibyapa by'umuhanda ibimenyetso by'umuhanda kwiga ibimenyetso by'umuhanda ikizamini cy'uruhushya rw'agateganyo ikizamini ikizamini cy'agateganyo ikizamini cy'amategeko amategeko y'umuhanda Rwanda amasomo y'amategeko y'umuhanda mu Rwanda kwiga ikizamini witegura ikizamini amasomo yo kwitegura ikizamini amasomo y'uruhushya rw'agateganyo kwiga perimi provisoire amasomo y'ibyapa by'umuhanda amasomo y'ibimenyetso by'umuhanda amasomo yuzuye kwiga bikoroheye`,
        quiz: `ikizamini cy'uruhushya rw'agateganyo ikizamini ikizamini cy'agateganyo ikizamini cy'amategeko ibibazo bya perimi provisoire perimi provisoire provisoire ikizamini amategeko y'umuhanda ikizamini cy'amategeko y'umuhanda twara kwiga twara twara neza ibyapa ibyapa by'umuhanda kwiga ibyapa ibimenyetso ibimenyetso by'umuhanda test quiz amategeko ibizami by'amategeko ikizamini cy'uruhushya rw'agateganyo mu Rwanda kora ikizamini witegura ikizamini ikizamini cyiza ibizami bya perimi provisoire quiz ikizamini test ikizamini ikizamini cy'ibyapa ikizamini cy'ibimenyetso ikizamini cyo kwiga twara ibibazo ibizamini kwiga amategeko`
      };
         }
     
     // Default fallback content
     return {
       home: `Rwanda traffic rules driving license preparation provisional driving test Rwanda driving exam questions how to pass Rwanda driving exam AB Drive driving school Rwanda`,
       course: `Rwanda traffic rules course driving license preparation Rwanda driving education course Rwanda permit course`,
       quiz: `Rwanda driving exam questions provisional driving test Rwanda how to pass Rwanda driving exam Rwanda traffic rules quiz`
     };
   };

  const keywordContent = getKeywordContent();
  const pageContent = keywordContent[page] || keywordContent.home || 'Rwanda traffic rules driving license preparation';

  // Schema.org WebPage structured data
  const getWebPageSchema = () => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": currentLanguage === 'fr' ? 
        (page === 'home' ? "Règles de circulation au Rwanda - Auto-École" : page === 'course' ? "Cours Auto-École Rwanda" : "Quiz Permis de Conduire Rwanda") :
        currentLanguage === 'rw' ?
        (page === 'home' ? "Amategeko y'umuhanda - Ishuri ry'amategeko" : page === 'course' ? "Amasomo y'amategeko" : "Ikizamini cy'amategeko") :
        (page === 'home' ? "Rwanda Traffic Rules - Driving School" : page === 'course' ? "Rwanda Driving Course" : "Rwanda Driving Quiz"),
      "url": `https://www.abdriverw.com${currentLanguage === 'en' ? '' : `/${currentLanguage}`}`,
      "description": currentLanguage === 'fr' ?
        "Auto-école Rwanda pour apprendre les règles de circulation et réussir l'examen permis de conduire Rwanda" :
        currentLanguage === 'rw' ?
        "Ishuri ry'amategeko y'umuhanda mu Rwanda kugira ngo utsinde ikizamini cy'uruhushya" :
        "Rwanda driving school to learn traffic rules and pass driving license exam",
      "inLanguage": currentLanguage,
      "isPartOf": {
        "@type": "WebSite",
        "name": "AB Drive",
        "url": "https://www.abdriverw.com"
      },
      "about": {
        "@type": "Thing",
        "name": currentLanguage === 'fr' ? "Formation permis de conduire Rwanda" : 
               currentLanguage === 'rw' ? "Kwiga amategeko y'umuhanda" : 
               "Rwanda driving license preparation"
      },
             "keywords": pageContent ? pageContent.split(' ').slice(0, 20).join(', ') : 'Rwanda traffic rules, driving license preparation',
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://www.abdriverw.com/images/logo/logo.webp"
      }
    };

    return JSON.stringify(schema);
  };

  return (
    <>
      {/* Hidden semantic content for SEO */}
      <div 
        style={{ 
          position: 'absolute', 
          left: '-10000px', 
          top: 'auto', 
          width: '1px', 
          height: '1px', 
          overflow: 'hidden' 
        }}
        aria-hidden="true"
             >
         <span>{pageContent || 'Rwanda traffic rules driving license preparation'}</span>
       </div>
      
      {/* WebPage Schema */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: getWebPageSchema() }} />
      
      {/* Additional microdata for search engines */}
      <div itemScope itemType="https://schema.org/EducationalOrganization" style={{ display: 'none' }}>
        <span itemProp="name">AB Drive</span>
        <span itemProp="description">
          {currentLanguage === 'fr' ? 
            "Auto-école Rwanda - Formation permis de conduire et règles de circulation" :
            currentLanguage === 'rw' ?
            "Ishuri ry'amategeko y'umuhanda - Kwiga amategeko no gutsinda ikizamini" :
            "Rwanda driving school - Traffic rules training and license preparation"
          }
        </span>
        <span itemProp="areaServed">Rwanda</span>
        <span itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
          <span itemProp="addressLocality">Kigali</span>
          <span itemProp="addressCountry">Rwanda</span>
        </span>
      </div>
    </>
  );
};

export default SEOKeywordContent; 